import React from "react";
import styles from "./style.m.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

const TnElectionHeader = props => {
  if (props.pageType === "mobile-webpage-page") {
    return null;
  }

  // Hide header if loaded from app
  if (typeof global !== "undefined" && global.location) {
    const regExp = /[?&]source=app(&|$)/;
    if (regExp.test(global.location.href)) {
      return null;
    }
  }
  let menuItems = get(props, ["menu", "items"], []);

  return (
    <div className={styles["header-outer"]}>
      {/* Menu */}
      {props.showMenu && (
        <nav className={styles["menu-nav"]}>
          <div className={styles["menu-nav-list-wrap"]}>
            {menuItems &&
              menuItems.length > 0 &&
              menuItems.map(item => {
                const hasSubMenu = item.items && Array.isArray(item.items) && item.items.length > 0;
                const slug = item.url || item.path;

                if (hasSubMenu) {
                  // Group menu with dropdown
                  return (
                    <div key={item.id} className={styles["menu-item-group"]}>
                      <span className={`${styles["menu-item"]} ${styles["menu-item-parent"]}`}>{item.title}</span>
                      <div className={styles["menu-submenu"]}>
                        {item.items.map(subItem => (
                          <a
                            key={subItem.id}
                            href={subItem.url || subItem.path}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles["menu-subitem"]}
                          >
                            {subItem.title}
                          </a>
                        ))}
                      </div>
                    </div>
                  );
                } else {
                  // Single menu item
                  return (
                    <a
                      key={item.id}
                      href={slug}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${styles["menu-item"]}`}
                    >
                      {item.title}
                    </a>
                  );
                }
              })}
          </div>
        </nav>
      )}
      {props.showBanner && (
        <div>
          <div className="hidden-mobile">
            <img
              src="https://media.vikatan.com/vikatan/2025-08-13/k53f6mi7/MyVikatanbanner1140x90Opt1a-1.png?format=webp&dpr=1.0&w=1140"
              alt=""
            />
          </div>
          <div className="hidden-desktop">
            <img
              src="https://media.assettype.com/vikatan/2025-08-13/as2nsvjc/MyVikatanbannerarticlemobiletopbanner375x120Opt1a-1.png?format=webp&w=400&dpr=1.0"
              alt=""
            />
          </div>
        </div>
      )}
    </div>
  );
};

TnElectionHeader.propTypes = {
  showMenu: PropTypes.bool,
  showBanner: PropTypes.bool,
  pageType: PropTypes.string,
  menu: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string.isRequired,
        url: PropTypes.string,
        path: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            title: PropTypes.string.isRequired,
            url: PropTypes.string,
            path: PropTypes.string
          })
        )
      })
    )
  })
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "header", "TNElectionHomeMenu"]),
    pageType: get(state, ["qt", "pageType"])
  };
}

export default connect(mapStateToProps)(TnElectionHeader);
